//CONSULTAR TOMADORES API
import { apiFetch } from "./apiFetch";

let cache = new Map();
let inFlight = new Map();
const CACHE_DURATION = 3000; // 3s

export const getTomadores = async (
  conversationId,
  limit = 20,
  before = null,
  search = ""
) => {
  try {
    const key = `tomadores|${conversationId}|${limit}|${before?.nome || "null"}|${before?.stamp || "null"}|${search || ""}`;
    const now = Date.now();

    // Retorna cache se ainda está válido
    if (cache.has(key)) {
      const cached = cache.get(key);
      if (now - cached.time < CACHE_DURATION) {
        return cached.data;
      }
    }

    // Se já há requisição em voo, reutiliza
    if (inFlight.has(key)) {
      return inFlight.get(key);
    }

    let url = `/tomadores?conversationId=${conversationId}&limit=${limit}`;

    if (search?.trim()) {
      url += `&search=${encodeURIComponent(search.trim())}`;
    }

    if (before?.nome && before?.stamp) {
      url += `&beforeNome=${encodeURIComponent(before.nome)}`;
      url += `&beforeStamp=${encodeURIComponent(before.stamp)}`;
    }

    const promise = (async () => {
      try {
        const response = await apiFetch(url);

        if (!response.ok) {
          throw new Error(`Erro na API: ${response.status}`);
        }

        const data = await response.json();

        const result = {
          tomadores: data.tomadores || [],
          hasMore: data.hasMore ?? false,
          nextCursor: data.nextCursor || null,
        };

        cache.set(key, {
          data: result,
          time: Date.now(),
        });

        return result;
      } finally {
        inFlight.delete(key);
      }
    })();

    inFlight.set(key, promise);
    return promise;

  } catch (error) {
    console.error("Erro ao buscar tomadores:", error);

    return {
      tomadores: [],
      hasMore: false,
      nextCursor: null,
    };
  }
};

export const getTomadoresContact = async (
  limit = 20,
  cursor = null,
  search = ""
) => {
  try {
    const key = `tomadores_contact|${limit}|${cursor?.nome || "null"}|${cursor?.stamp || "null"}|${search || ""}`;
    const now = Date.now();

    // Retorna cache se ainda está válido
    if (cache.has(key)) {
      const cached = cache.get(key);
      if (now - cached.time < CACHE_DURATION) {
        return cached.data;
      }
    }

    // Se já há requisição em voo, reutiliza
    if (inFlight.has(key)) {
      return inFlight.get(key);
    }

    let url = `/tomadores/contact?limit=${limit}`;

    if (search?.trim()) {
      url += `&search=${encodeURIComponent(search.trim())}`;
    }

    if (!search?.trim() && cursor?.nome && cursor?.stamp) {
      url += `&beforeNome=${encodeURIComponent(cursor.nome)}`;
      url += `&beforeStamp=${encodeURIComponent(cursor.stamp)}`;
    }

    const promise = (async () => {
      try {
        const response = await apiFetch(url);

        if (!response.ok) {
          throw new Error(`Erro na API: ${response.status}`);
        }

        const data = await response.json();

        const result = {
          tomadores: data?.tomadores || [],
          hasMore: data?.hasMore ?? false,
          nextCursor: data?.nextCursor || null,
        };

        cache.set(key, {
          data: result,
          time: Date.now(),
        });

        return result;
      } finally {
        inFlight.delete(key);
      }
    })();

    inFlight.set(key, promise);
    return promise;

  } catch (error) {
    console.error("Erro ao buscar tomadores:", error);

    return {
      tomadores: [],
      hasMore: false,
      nextCursor: null,
    };
  }
};


export const getTomadorByStamp = async (stamp) => {
  if (!stamp) {
    return null;
  }

  const key = `tomador_by_stamp|${stamp}`;
  const now = Date.now();

  try {
    // Cache válido
    if (cache.has(key)) {
      const cached = cache.get(key);
      if (now - cached.time < CACHE_DURATION) {
        return cached.data;
      }
    }

    // Requisição em voo
    if (inFlight.has(key)) {
      return inFlight.get(key);
    }

    const url = `/tomadores/contact?stamp=${encodeURIComponent(stamp)}`;

    const promise = (async () => {
      try {
        const response = await apiFetch(url);

        if (!response.ok) {
          throw new Error(`Erro na API: ${response.status}`);
        }

        const data = await response.json();

        // Assumindo que a API devolve um único tomador ou dentro de um array
        const tomador =
          data?.tomador ||
          (Array.isArray(data?.tomadores) ? data.tomadores[0] : null) ||
          null;

        cache.set(key, {
          data: tomador,
          time: Date.now(),
        });

        return tomador;
      } finally {
        inFlight.delete(key);
      }
    })();

    inFlight.set(key, promise);
    return promise;

  } catch (error) {
    console.error("Erro ao buscar tomador por stamp:", error);
    return null;
  }
};



//CONSULTAR UTILIZADORES API
export const getUtilizadores = async (
  conversationId,
  limit = 20,
  before = null,
  search = ""
) => {
  try {
    const key = `utilizadores|${conversationId}|${limit}|${before?.nome || "null"}|${before?.stamp || "null"}|${search || ""}`;
    const now = Date.now();

    // Retorna cache se ainda está válido
    if (cache.has(key)) {
      const cached = cache.get(key);
      if (now - cached.time < CACHE_DURATION) {
        return cached.data;
      }
    }

    // Se já há requisição em voo, reutiliza
    if (inFlight.has(key)) {
      return inFlight.get(key);
    }

    let url = `/utilizadores?chatstp=${conversationId}&limit=${limit}`;

    if (search?.trim()) {
      url += `&search=${encodeURIComponent(search.trim())}`;
    }

    if (before?.nome && before?.stamp) {
      url += `&beforeNome=${encodeURIComponent(before.nome)}`;
      url += `&beforeStamp=${encodeURIComponent(before.stamp)}`;
    }

    const promise = (async () => {
      try {
        const response = await apiFetch(url);

        if (!response.ok) {
          throw new Error(`Erro na API: ${response.status}`);
        }

        const data = await response.json();

        const result = {
          utilizadores: data.utilizadores || [],
          hasMore: data.hasMore ?? false,
          nextCursor: data.nextCursor || null,
        };

        cache.set(key, {
          data: result,
          time: Date.now(),
        });

        return result;
      } finally {
        inFlight.delete(key);
      }
    })();

    inFlight.set(key, promise);
    return promise;

  } catch (error) {
    console.error("Erro ao buscar utilizadores:", error);

    return {
      utilizadores: [],
      hasMore: false,
      nextCursor: null,
    };
  }
};

export const getUtilizadoresContact = async (
  limit = 20,
  before = null,
  search = ""
) => {
  try {
    const key = `utilizadores_contact|${limit}|${before?.nome || "null"}|${before?.stamp || "null"}|${search || ""}`;
    const now = Date.now();

    // Retorna cache se ainda está válido
    if (cache.has(key)) {
      const cached = cache.get(key);
      if (now - cached.time < CACHE_DURATION) {
        return cached.data;
      }
    }

    // Se já há requisição em voo, reutiliza
    if (inFlight.has(key)) {
      return inFlight.get(key);
    }

    let url = `/utilizadores/contact?limit=${limit}`;

    if (search?.trim()) {
      url += `&nome=${encodeURIComponent(search.trim())}`;
    }

    if (before?.nome && before?.stamp) {
      url += `&beforeNome=${encodeURIComponent(before.nome)}`;
      url += `&beforeStamp=${encodeURIComponent(before.stamp)}`;
    }

    const promise = (async () => {
      try {
        const response = await apiFetch(url);

        if (!response.ok) {
          throw new Error(`Erro na API: ${response.status}`);
        }

        const data = await response.json();

        const utilizadores = data?.utilizadores || [];

        const result = {
          utilizadores,
          hasMore: data?.hasMore ?? (utilizadores.length === limit),
          lastCursor:
            utilizadores.length > 0
              ? {
                  nome: utilizadores[utilizadores.length - 1].NOME,
                  stamp: utilizadores[utilizadores.length - 1].STAMP,
                }
              : null,
        };

        cache.set(key, {
          data: result,
          time: Date.now(),
        });

        return result;
      } finally {
        inFlight.delete(key);
      }
    })();

    inFlight.set(key, promise);
    return promise;

  } catch (error) {
    console.error("Erro ao buscar utilizadores:", error);

    return {
      utilizadores: [],
      hasMore: false,
      lastCursor: null,
    };
  }
};